// extracted by mini-css-extract-plugin
export var actions = "_5x-8";
export var arrow = "_5x-5";
export var card = "_5x-0";
export var cardWrapper = "_5x-9";
export var fieldName = "_5x-3";
export var newValue = "_5x-6";
export var oldValue = "_5x-4";
export var orangeGlowFade = "_5x-c";
export var productSection = "_5x-1";
export var scrollToBottom = "_5x-b";
export var scrollToBottomAnchor = "_5x-a";
export var scrollToBottomIcon = "_5x-d";
export var showAllButton = "_5x-7";
export var table = "_5x-2";